
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/happy-hour",
      function () {
        return require("private-next-pages/happy-hour/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/happy-hour"])
      });
    }
  